import * as React from "react";
import type { SVGProps } from "react";
const DentalCare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_7533)">
      <path
        fill="currentColor"
        d="M9.9702 1.0763c-.9-.6964-2.0036-1.0768-3.1393-1.0768-2.8286 0-5.116 2.2875-5.116 5.116v.3322c0 .8464.1982 1.6768.5732 2.4375l1.2589 2.5232c.241.4768.4071.9857.5036 1.5107l1.966 11.025c.1072.6.6215 1.0393 1.2268 1.0608.6054.0214 1.1464-.3965 1.2857-.9858l1.5482-6.4982c.2197-.8946 1.0125-1.5214 1.9233-1.5214.9107 0 1.7035.6268 1.9178 1.5161l1.5482 6.4982c.1393.5946.6804 1.0071 1.2857.9857s1.1197-.4607 1.2268-1.0607l1.9661-11.025c.0964-.525.2625-1.0339.5036-1.5107l1.2589-2.5232c.3804-.7554.5732-1.5911.5732-2.4375v-.1125c0-2.9465-2.3893-5.3358-5.3357-5.3358-1.2911 0-2.5393.4715-3.5143 1.3179l-.1714.15 1.0446.8143c.375.2893.4393.8303.15 1.2053s-.8303.4393-1.2053.15l-1.3072-1.0178-1.9821-1.5429z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4355_7533">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default DentalCare;
